import { createSelector } from 'reselect';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { promiseBopisNodes } from 'yoda-site-components/lib/common/ProductConstants';

const getProductOffering = (state) => state.productOffering || {};
const getFeatureFlags = (state) => (state.context && state.context.featureFlags) || {};
const getBopusStoreNode = () => promiseBopisNodes.aggregatedBopusNode;

const getHolidayMessage = createSelector(
    [getProductOffering, getFeatureFlags],
    (productOffering, featureFlags) => {
        const { promise } = productOffering;
        const deliveryOptions =
            promise &&
            promise.skuDeliveryOptions &&
            promise.skuDeliveryOptions.length &&
            promise.skuDeliveryOptions[0] &&
            promise.skuDeliveryOptions[0].deliveryOptions
                ? promise.skuDeliveryOptions[0].deliveryOptions
                : null;
        let holidayMessage = {};
        if (deliveryOptions) {
            const bopisStoreNode = getBopusStoreNode();
            const bopisHolidayMessage = get(
                deliveryOptions,
                `${bopisStoreNode}.locationIds[0].holidayMessage`,
                ''
            );
            const bopisHolidayId = get(
                deliveryOptions,
                `${bopisStoreNode}.locationIds[0].holidayId`,
                ''
            );
            if (
                deliveryOptions.shipToHome &&
                deliveryOptions.shipToHome.serviceLevels &&
                deliveryOptions.shipToHome.serviceLevels.length &&
                deliveryOptions.shipToHome.serviceLevels[0].holidayMessage &&
                deliveryOptions.shipToHome.serviceLevels[0].holidayId
            ) {
                const { holidayId } = deliveryOptions.shipToHome.serviceLevels[0];
                holidayMessage = {
                    deliveryMethod: 'shipToHome',
                    holidayMessage: deliveryOptions.shipToHome.serviceLevels[0].holidayMessage,
                    holidayIcon: holidayId.toLowerCase().replace('_', '-'),
                };
            } else if (!isEmpty(bopisHolidayMessage) && !isEmpty(bopisHolidayId)) {
                holidayMessage = {
                    deliveryMethod: 'bopus',
                    holidayMessage: bopisHolidayMessage,
                    holidayIcon: bopisHolidayId.toLowerCase().replace('_', '-'),
                };
            }
        }
        return holidayMessage;
    }
);

export default getHolidayMessage;
